import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Image, Platform, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { decode } from 'html-entities';
import { Hyperlink } from 'react-native-hyperlink';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import timeUtils from '../../utils/timeUtils';
import truncate from '../../utils/truncate';

class UpdateThread extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    thread: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any),
  };

  backToUpdates = () => {
    const { actions } = this.props;
    actions.backToUpdates();
  };

  goToPantry = () => {
    const { navigation, thread, actions } = this.props;
    const { updates } = thread;
    const pantryId = updates[0].pantry_id;
    if (Layout.usePantryTabs) {
      navigation.navigate('Pantry', { id: pantryId });
    } else {
      navigation.navigate('a', {
        screen: 'pantries',
        params: { id: pantryId },
      });
      actions.showSinglePantry(pantryId);
    }
  };

  renderItem = (item) => {
    const { locale } = this.props;
    const date = timeUtils.getShortDateFromUnixTimestamp(item.date, locale || 'en');
    let textWithLinks = null;
    if (item.from_user) {
      textWithLinks = <Text style={styles.blueCardText}>{decode(item.description)}</Text>;
      try {
        textWithLinks = (
          <Hyperlink linkDefault={true} linkStyle={styles.linkStyle}>
            <Text style={styles.blueCardText}>{decode(item.description)}</Text>
          </Hyperlink>
        );
      } catch (error) {
        console.log(error);
      }
    } else {
      textWithLinks = <Text style={styles.describedText}>{decode(item.description)}</Text>;
      try {
        textWithLinks = (
          <Hyperlink linkDefault={true} linkStyle={styles.linkStyle}>
            <Text style={styles.describedText}>{decode(item.description)}</Text>
          </Hyperlink>
        );
      } catch (error) {
        console.log(error);
      }
    }

    if (item.from_user) {
      return (
        <View style={[styles.cardViewBlue]} key={`Update-Item-${item.id}`}>
          <Image style={styles.blueCardImage} source={require('../../assets/images/plentiful-logo.png')} />
          <Text style={styles.blueCardDate}>{date}</Text>
          {textWithLinks}
        </View>
      );
    } else {
      return (
        <View style={[styles.openCardView]} key={`Update-Item-${item.id}`}>
          <Image style={styles.openCardImage} source={{ uri: item.avatar }} />
          <Text style={styles.dateView}>{date}</Text>
          {textWithLinks}
        </View>
      );
    }
  };

  render() {
    const { thread } = this.props;
    const { updates } = thread;
    if (!updates || !updates.length) return null;
    const pantryName = updates[0].pantry_name;

    return (
      <View style={styles.view}>
        <View style={styles.header}>
          <TouchableOpacity onPress={this.backToUpdates} style={styles.backButton}>
            <MaterialIcons name={'arrow-back'} size={24} color={Colors.mediumBlue} />
          </TouchableOpacity>
          <TouchableOpacity onPress={this.goToPantry} style={styles.titleContainer}>
            <Text style={styles.headerTitle}>{truncate(pantryName, 24)}</Text>
          </TouchableOpacity>
        </View>
        <ScrollView style={styles.scrollContainer} contentContainerStyle={styles.contentContainer}>
          {updates.map((item) => this.renderItem(item))}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  view: {
    color: Colors.primaryColor,
    backgroundColor: Colors.lightBackground,
    flex: 1,
    alignItems: 'center',
  },
  header: {
    marginHorizontal: 0,
    padding: 16,
    height: 56,
    backgroundColor: Colors.white,
    flexDirection: 'row',
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    width: '100%',
  },
  backButton: {
    marginRight: 24,
  },
  openCardView: {
    marginHorizontal: 0,
    padding: 8,
    marginTop: 42,
    backgroundColor: Colors.white,
    paddingVertical: 20,
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
  },
  titleContainer: {
    marginTop: Platform.OS == 'android' ? -4 : 0,
  },
  headerTitle: {
    fontSize: 20,
    color: Colors.mediumBlue,
    fontWeight: '500',
  },
  scrollContainer: {
    flex: 1,
    maxWidth: 720,
    width: '100%',
  },
  contentContainer: {
    paddingBottom: 56,
    backgroundColor: Colors.lightBackground,
  },
  updateView: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  openCardImage: {
    width: 40,
    height: 40,
    position: 'absolute',
    top: -20,
    left: 10,
  },
  describedText: {
    fontSize: 17,
    padding: 12,
  },
  dateView: {
    position: 'absolute',
    right: 12,
    top: 8,
    color: Colors.grayText,
  },
  cardViewBlue: {
    marginHorizontal: 0,
    padding: 8,
    marginTop: 42,
    paddingVertical: 20,
    backgroundColor: Colors.darkBlue,
  },
  blueCardText: {
    color: Colors.white,
    fontSize: 17,
    padding: 12,
  },
  blueCardImage: {
    width: 40,
    height: 40,
    position: 'absolute',
    top: -20,
    right: 10,
  },
  blueCardDate: {
    color: Colors.white,
    paddingLeft: 12,
  },
  linkStyle: {
    color: Colors.mediumBlue,
    padding: 0,
    margin: 0,
  },
});

export default UpdateThread;
